const WORKSPACE_KEY = 'code-session-workspace';

/** These spellings resolve to the same path in the session's /mnt/workspace. */
export function normalizeWorkspacePath(path: string): string {
  // Keep path spellings whose resolution can change across a symlink or an
  // extra root separator; they must not share a cache key with another file.
  if (path.split('/').includes('..') || path.startsWith('/mnt/workspace//')) {
    return path;
  }
  let normalized = path.startsWith('/mnt/workspace/') ? path.slice('/mnt/workspace/'.length) : path;
  while (normalized.startsWith('./')) {
    normalized = normalized.slice(2);
  }
  // Stripping `.//` would turn a repository-relative path into an absolute
  // one (including when it occurs after the workspace prefix).
  if (normalized !== path && normalized.startsWith('/')) {
    return path;
  }
  return normalized;
}

export const codeSessionWorkspaceKeys = {
  root: [WORKSPACE_KEY] as const,
  all: (sessionId: string) => [WORKSPACE_KEY, sessionId] as const,
  file: (sessionId: string, path: string) =>
    [WORKSPACE_KEY, sessionId, 'file', normalizeWorkspacePath(path)] as const,
  changes: (sessionId: string) => [WORKSPACE_KEY, sessionId, 'changes'] as const,
  git: (sessionId: string) => [WORKSPACE_KEY, sessionId, 'git'] as const,
  pullRequest: (sessionId: string) => [WORKSPACE_KEY, sessionId, 'pull-request'] as const,
  preview: (sessionId: string) => [WORKSPACE_KEY, sessionId, 'preview'] as const,
  diff: (sessionId: string, path: string, base: string) =>
    [WORKSPACE_KEY, sessionId, 'diff', normalizeWorkspacePath(path), base] as const,
};
